import React from 'react';
import Label from './Label';
export default function TextArea({ label, noMargin, placeholder, value, onChange, name, disabled, error, message }) {
	return (
		<div className={noMargin ? 'mt-2' : ''}>
			{label && <Label text={label} />}
			<textarea
				type="text"
				className={`
                    form-control
                    block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    transition
                    ease-in-out
                    m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
				 	${disabled ? 'bg-slate-50' : ''}
					`}
				id={name}
				name={name}
				disabled={disabled}
				onChange={onChange}
				value={value}
				placeholder={placeholder}
			/>
			{message}
			{error && <div className="text-red-600">{error}</div>}
		</div>
	);
}
